"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNumericInputContainer = exports.StyledNumericInput = exports.NumberInputControlButtonUp = exports.NumberInputControlButtonDown = exports.NumberInputContainer = exports.NumberInputAddonContainer = exports.MobileControlButton = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("./../Icon/StyledIcon"));
var _TextInput = require("../TextInput");
var _StyledTextInput = require("../TextInput/StyledTextInput");
var _StyledButton = _interopRequireDefault(require("../Button/StyledButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getSize = function getSize(props) {
  return props.theme.input.sizes[props.size] || props.theme.input.sizes['medium'];
};
var NumberInputAddonContainer = exports.NumberInputAddonContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-v841pl-0"
})(["height:100%;outline:0;border:0;padding:0;margin:0 ", "px;"], function (props) {
  return getSize(props).iconMargin;
});
var StyledNumericInputContainer = exports.StyledNumericInputContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-v841pl-1"
})(["", "{background-color:", ";&:last-child{", "}}min-width:80px;display:inline-block;position:relative;width:", ";", ""], _StyledTextInput.StyledInputAddon, function (props) {
  return props.disabled ? props.theme.input.disabled.backgroundColor : props.theme.input.backgroundColorType[props.$backgroundColorType] || props.theme.input.backgroundColorType.default;
}, function (props) {
  return props.addonAfter && (0, _ykbStyledComponents.css)(["border-bottom-right-radius:0;border-top-right-radius:0;"]);
}, function (props) {
  return props.width || props.theme.input.numberInput.width;
}, function (props) {
  return props.disabled && (0, _ykbStyledComponents.css)(["background-color:", ";"], function (props) {
    return props.theme.input.disabled.backgroundColor;
  });
});
var NumberInputContainer = exports.NumberInputContainer = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-v841pl-2"
})(["position:relative;display:table;width:100%;.addon-after{height:", ";border-bottom-right-radius:", " !important;border-top-right-radius:", " !important;background:", ";", "{height:", ";}}"], function (props) {
  return getSize(props).height;
}, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return props.theme.input.addon.backgroundColor;
}, _StyledButton.default, function (props) {
  return getSize(props).height;
});
var StyledNumericInput = exports.StyledNumericInput = (0, _ykbStyledComponents.default)(_TextInput.TextInput).withConfig({
  componentId: "ykb-ui__sc-v841pl-3"
})(["text-align:center;", " ", " ", ""], function (props) {
  return !props.mobile && !props.$hideSpinner && (0, _ykbStyledComponents.css)(["border-right:", ";"], function (props) {
    return !props.allowClear ? props.theme.input.borderRight : 'none';
  });
}, function (props) {
  return props.$hideSpinner && props.$customAddonAfter && (0, _ykbStyledComponents.css)(["border-top-right-radius:0px;border-bottom-right-radius:0px;"]);
}, function (props) {
  return props.focusAll && props.$hideSpinner && (0, _ykbStyledComponents.css)(["&:focus,&.focused{border:1px solid ", ";box-shadow:0 0 3px 3px rgba(194,225,255,0.95);}"], function (props) {
    return props.theme.input.hover.borderColor;
  });
});
var NumberInputControlButtonUp = exports.NumberInputControlButtonUp = _ykbStyledComponents.default.b.withConfig({
  componentId: "ykb-ui__sc-v841pl-4"
})(["text-align:center;cursor:", ";float:left;font-size:", ";position:absolute;color:", ";overflow:hidden;background:", ";width:100%;height:50%;left:0;top:0;border-top-right-radius:4px;display:flex;justify-content:center;align-items:flex-end;", " &:hover{", "{color:", ";}}"], function (props) {
  return props.disabled ? 'not-allowed' : 'default';
}, function (props) {
  return props.theme.icon.size.small.fontSize;
}, function (props) {
  return props.theme.input.disabled.color;
}, function (props) {
  return props.disabled ? props.theme.input.disabled.backgroundColor : props.theme.input.backgroundColorType[props.$backgroundColorType] || props.theme.input.backgroundColorType.default;
}, function (props) {
  return props.size === 'small' && (0, _ykbStyledComponents.css)(["", "{font-size:", ";}"], _StyledIcon.default, function (props) {
    return props.theme.icon.size.xsmall.fontSize;
  });
}, _StyledIcon.default, function (props) {
  return props.disabled ? function (props) {
    return props.theme.input.disabled.color;
  } : props.theme.color.primary6;
});
var NumberInputControlButtonDown = exports.NumberInputControlButtonDown = _ykbStyledComponents.default.b.withConfig({
  componentId: "ykb-ui__sc-v841pl-5"
})(["text-align:center;cursor:", ";float:left;font-size:", ";position:absolute;color:", ";overflow:hidden;background:", ";width:100%;height:50%;left:0;bottom:0;border-bottom-right-radius:4px;display:flex;justify-content:center;align-items:flex-start;", " &:hover{", "{color:", ";}}"], function (props) {
  return props.disabled ? 'not-allowed' : 'default';
}, function (props) {
  return props.theme.icon.size.small.fontSize;
}, function (props) {
  return props.theme.input.disabled.color;
}, function (props) {
  return props.disabled ? props.theme.input.disabled.backgroundColor : props.theme.input.backgroundColorType[props.$backgroundColorType] || props.theme.input.backgroundColorType.default;
}, function (props) {
  return props.size === 'small' && (0, _ykbStyledComponents.css)(["", "{font-size:", ";}"], _StyledIcon.default, function (props) {
    return props.theme.icon.size.xsmall.fontSize;
  });
}, _StyledIcon.default, function (props) {
  return props.disabled ? function (props) {
    return props.theme.input.disabled.color;
  } : props.theme.color.primary6;
});
var MobileControlButton = exports.MobileControlButton = _ykbStyledComponents.default.b.withConfig({
  componentId: "ykb-ui__sc-v841pl-6"
})(["margin:-10px;padding:", ";text-align:center;cursor:", ";float:left;", "{vertical-align:middle;font-size:", ";color:", ";}> svg{vertical-align:middle;}"], function (props) {
  if (props.size === 'small') return '5px 5px';else if (props.size === 'large') return '10px 10px';
  return '7px';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'default';
}, _StyledIcon.default, function (props) {
  return getSize(props).fontSize;
}, function (props) {
  return props.disabled ? function (props) {
    return props.theme.input.disabled.color;
  } : props.theme.color.primary6;
});